module.exports = __webpack_public_path__ + "img/selo-gratis-7.25189039.png";